import type { SpartacuxShoppingCartState } from '../../ShoppingCartState';
import { queueToList } from '../utils/queueToList';

export function getFlashQueue(state: SpartacuxShoppingCartState) {
  return queueToList(state.shoppingCart?.flashMessage?.alertMessages || []);
}
